
import * as Turbo from '@hotwired/turbo'
Turbo.start()
import "../controllers"

document.addEventListener("turbo:load", function() {
  if (document.querySelector(".cf-turnstile") && window.turnstile) {
     window.turnstile.render(".cf-turnstile")
  }
})
